import { takeEvery, call, put, select, all } from 'redux-saga/effects';
import {
  initState as initRequestStatusState,
  requestInProcess,
  requestFinished,
  setCodeResponse
} from '../../../../common/reducers/_requestStatus/reducer';
import {
  initState as initStateFormErrors,
  setErrors,
  clearErrors,
  selectFirstErrorByFiled
} from '../../../../common/reducers/_formErrors/reducer';
import { sendForm, initState, setResultObject } from './actions';
import { selectFormBody } from './selectors';
import { timeoutCall } from '../../../../utils/sagaHalper';
import CommentsService from '../../services';
import * as clientNoticesActions from '../../../main/reducers/static/states/clientNotices/reducer';
import { restructureCommentModel } from '../../restructuring';

function* sendComment(reducerName) {
  const formBody = yield select(selectFormBody, reducerName);
  yield put(requestInProcess(reducerName));
  try {
    yield put(clearErrors(reducerName));
    const response = yield call(
      timeoutCall,
      CommentsService.sendComment,
      formBody
    );
    if (response) {
      if (response.status === 201) {
        yield put(
          setResultObject(reducerName, restructureCommentModel(response.data))
        );
        console.log('add comment success');
      } else if (response.status === 422) {
        yield put(setErrors(reducerName, response.data));

        // TODO На стороне серера должно быть исключение на проверку выполнения а не ошибка валидации.
        const modelIdError = yield select(
          selectFirstErrorByFiled,
          reducerName,
          'model_id'
        );
        if (modelIdError) {
          yield put(
            clientNoticesActions.addClientNotice({
              type: 'error',
              title: 'Комментарий не отправлен',
              message: modelIdError.message
            })
          );
        }
      }
      yield put(setCodeResponse(reducerName, response.status));
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName));
}

function* initStates(reducerName) {
  yield put(initRequestStatusState(reducerName));
  yield put(initStateFormErrors(reducerName));
}

export default function* createSaga(reducerName) {
  yield all([
    takeEvery(sendForm(reducerName).type, sendComment, reducerName),
    takeEvery(initState(reducerName).type, initStates, reducerName)
  ]);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/comments/reducers/form/saga.js